import { render, staticRenderFns } from "./DocumentTemplateWorkspace.vue?vue&type=template&id=05189a6a&scoped=true&"
import script from "./DocumentTemplateWorkspace.vue?vue&type=script&lang=js&"
export * from "./DocumentTemplateWorkspace.vue?vue&type=script&lang=js&"
import style0 from "./DocumentTemplateWorkspace.vue?vue&type=style&index=0&id=05189a6a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05189a6a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('05189a6a')) {
      api.createRecord('05189a6a', component.options)
    } else {
      api.reload('05189a6a', component.options)
    }
    module.hot.accept("./DocumentTemplateWorkspace.vue?vue&type=template&id=05189a6a&scoped=true&", function () {
      api.rerender('05189a6a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/cargo/v0/SystemMaintenance/documentTemplateManagement/components/DocumentTemplateWorkspace.vue"
export default component.exports